// ==========================================================================
// Form normalize
// Author: Globalia
// Licensed under the WTFPL license
// ==========================================================================

import {
    toggleAttributeValue,
    removeAttributeValue
} from 'groots/utilities';

import GrFormSelect from 'groots/buds/grFormSelect/grFormSelect';
import GrFormUpload from 'groots/buds/grFormUpload/grFormUpload';

class GrFormNormalize {
    constructor(selector) {
        this.pluginName = 'grFormNormalize';

        // Create global references
        this.selector = typeof selector === 'string' ? document.querySelector(selector) : selector;

        // Init
        this.init();
    }

    //  Methods
    // --------------------------------------------------------------------------

    init() {
        this.normelizeHubspot();



        if (window.groots.plugins.grFormUpload !== undefined) {
            // Re-initialize form file inputs
            const fileInputs = this.selector.querySelectorAll('input[type="file"]');

            if (fileInputs.length) {
                let globIndex = -1;
                let index = -1;

                if ( window.groots.plugins.grFormUpload.instances === undefined ) {
                    window.groots.plugins.grFormUpload.instances = {};
                } else {
                    globIndex = Object.keys(window.groots.plugins.grFormUpload.instances).length;
                }

                while (fileInputs[++index]) {
                    window.groots.plugins.grFormUpload.instances[globIndex] = new GrFormUpload(fileInputs[index]);
                }
            }
        }

        toggleAttributeValue(this.selector, 'gr-form-normalize', 'ready');

        if (window.groots.verbose) {
            console.warn(this.pluginName + ': ready');
        }
    }

    normelizeHubspot() {
        if (window.groots.verbose) {
            console.warn(this.pluginName + ': processing start');
        }

        toggleAttributeValue(this.selector, 'gr-form-normalize', 'processing');

        // Make sure that checkbox and radio are positionned before their label
        var checkboxes = this.selector.querySelectorAll('input[type="checkbox"]');

        for (let i = checkboxes.length - 1; i >= 0; i--) {
            const label = this.selector.querySelector('label[for="' + checkboxes[i].getAttribute('id') + '"].hs-form-booleancheckbox-display, label[for="' + checkboxes[i].getAttribute('id') + '"].hs-form-checkbox-display');

            checkboxes[i].parentNode.parentNode.insertBefore(checkboxes[i], label);
        }


        var radios = this.selector.querySelectorAll('input[type="radio"]');

        for (let i = radios.length - 1; i >= 0; i--) {
            const label = this.selector.querySelector('label[for="' + radios[i].getAttribute('id') + '"].hs-form-radio-display');

            radios[i].parentNode.parentNode.insertBefore(radios[i], label);
        }

        // Make sure that file input labels are positionned after
        var fileInputs = this.selector.querySelectorAll('input[type="file"]');

        for (let i = fileInputs.length - 1; i >= 0; i--) {
            const label = this.selector.querySelector('label[for="' + fileInputs[i].getAttribute('id') + '"]');

            fileInputs[i].parentNode.insertBefore(label, fileInputs[i].nextSibling);
        }

        removeAttributeValue(this.selector, 'gr-form-normalize', 'processing');

        if (window.groots.verbose) {
            console.warn(this.pluginName + ': processed');
        }
    }

    // Destroy - remove listeners to prevent from memory leak
    destroy() {
        removeAttributeValue(this.selector, 'gr-form-normalize', 'ready processing');

        if (window.groots.verbose) {
            console.warn(this.pluginName + ': destroyed');
        }
    }
}

export default GrFormNormalize;

//  Auto-Instantiation
// ----------------------------------------------------------------------

(function() {
    const all = document.querySelectorAll('[gr-form-normalize]');
    window.groots.plugins.grFormNormalize = {};

    window.addEventListener('load', function () {
        if (all.length) {
            window.groots.plugins.grFormNormalize.instances = {};
            let index = -1;

            while (all[++index]) {
                window.groots.plugins.grFormNormalize.instances[index] = new GrFormNormalize(all[index]);
            }
        }
    }, false);
}());
